import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import type { FC, ReactNode } from 'react';
import './style.css';

const InputError: FC<{
	children: ReactNode;
	name: string;
	position?: 'left' | 'center';
	isError: boolean;
	className?: string;
}> = ({ children, name, position = 'left', isError = false, className = '' }) => {
	const id = `${name}_error`;

	return (
		<Transition show={isError}>
			<div
				className={clsx(
					'opacity-1 scale-100 duration-100',
					'data-[closed]:opacity-0 data-[closed]:scale-95',
					'input-error absolute -bottom-3 p-3 flex items-center text-sm rounded-[4px] translate-y-full z-10 shadow-input-error-panel',
					position === 'left' ? 'left-0' : 'left-1/2 -translate-x-1/2',
					className,
				)}
				id={id}
				data-testid={id}
				role={isError ? 'alert' : ''}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="23"
					height="20"
					viewBox="0 0 23 20"
					className="input-error-triangle absolute top-px -translate-y-full left-[7px] w-3 h-3"
				>
					<path
						d="M9.766 3.015a2 2 0 0 1 3.468 0L21.277 17a2 2 0 0 1-1.734 3H3.457a2 2 0 0 1-1.734-3Z"
						fill="#fff"
					/>
				</svg>
				<svg
					width="14"
					height="14"
					viewBox="0 0 14 14"
					className="w-4 h-4 mr-2"
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M7.00001 10.5C7.16334 10.5 7.30043 10.4446 7.41126 10.3337C7.52209 10.2229 7.57751 10.0858 7.57751 9.92248C7.57751 9.75915 7.52209 9.62207 7.41126 9.51124C7.30042 9.4004 7.16334 9.34499 7.00001 9.34499C6.83668 9.34499 6.69959 9.40041 6.58876 9.51124C6.47792 9.62208 6.42252 9.75915 6.42252 9.92248C6.42252 10.0858 6.47794 10.2229 6.58876 10.3337C6.69959 10.4446 6.83668 10.5 7.00001 10.5ZM6.5275 7.8226H7.5775V3.39509H6.5275V7.8226ZM7 14C6.04334 14 5.13916 13.8162 4.2875 13.4488C3.43583 13.0812 2.69208 12.5796 2.05625 11.9438C1.42042 11.3079 0.918753 10.5642 0.551248 9.71251C0.183742 8.86084 0 7.95084 0 6.9825C0 6.02584 0.183753 5.12167 0.551248 4.27C0.918743 3.41833 1.42041 2.67751 2.05625 2.04749C2.69208 1.41749 3.43583 0.918742 4.2875 0.551247C5.13916 0.183742 6.04917 0 7.0175 0C7.97417 0 8.87834 0.183753 9.73 0.551247C10.5817 0.918742 11.3225 1.41749 11.9525 2.04749C12.5825 2.67749 13.0812 3.41832 13.4488 4.27C13.8162 5.12167 14 6.03167 14 7C14 7.95667 13.8162 8.86083 13.4488 9.71249C13.0812 10.5642 12.5825 11.3079 11.9525 11.9437C11.3225 12.5796 10.5817 13.0812 9.73 13.4487C8.87833 13.8162 7.96833 14 6.99999 14L7 14ZM7.0175 12.95C8.6625 12.95 10.0625 12.3696 11.2175 11.2087C12.3725 10.0479 12.95 8.63915 12.95 6.98248C12.95 5.33748 12.3725 3.93748 11.2175 2.78248C10.0625 1.62748 8.65668 1.04997 7.00001 1.04997C5.35501 1.04997 3.95209 1.62747 2.79125 2.78247C1.63041 3.93747 1.05 5.34331 1.05 6.99997C1.05 8.64497 1.63042 10.0479 2.79125 11.2087C3.95209 12.3696 5.36083 12.95 7.0175 12.95Z"
						fill="#FF1400"
					/>
				</svg>
				{children}
			</div>
		</Transition>
	);
};

export default InputError;
